const rankingItems = [
  { rank: 1, title: '某顶流被曝深夜密会神秘女子，酒店同框画面曝光', heat: '980W', tag: '爆', tagColor: 'bg-primary-500' },
  { rank: 2, title: '知名网红直播间翻车，口误透露行业内幕引热议', heat: '856W', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 3, title: '娱乐圈再爆税务风波，多位艺人被约谈调查', heat: '742W', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 4, title: '某综艺录制现场突发冲突，节目组紧急发声明', heat: '631W', tag: '新', tagColor: 'bg-secondary-500' },
  { rank: 5, title: '豪门恋情曝光！富二代与女星牵手逛街被拍', heat: '528W', tag: '新', tagColor: 'bg-secondary-500' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            吃瓜热搜榜
          </h2>
          <span className="px-2 py-0.5 text-xs font-medium bg-primary-100 text-primary-700 rounded whitespace-nowrap">
            实时更新
          </span>
        </div>
        <p className="text-sm text-foreground-600 mb-8 ml-4">全网最热明星黑料与网红八卦实时排行，每5分钟刷新一次</p>

        <div className="bg-background-100 rounded-2xl overflow-hidden">
          {rankingItems.map((item, idx) => (
            <a
              key={item.rank}
              href="#ranking"
              onClick={(e) => e.preventDefault()}
              className={`flex items-center gap-4 px-5 py-4 hover:bg-background-200/70 transition-colors cursor-pointer ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              {/* Rank number */}
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center font-heading font-bold text-lg shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-accent-400 text-background-50' :
                'bg-secondary-200 text-secondary-700'
              }`}>
                {item.rank}
              </div>

              {/* Title */}
              <span className="flex-1 text-sm md:text-base font-medium text-foreground-800 leading-snug">
                {item.title}
              </span>

              {/* Tag */}
              <span className={`px-2.5 py-1 text-xs font-bold text-background-50 rounded-md shrink-0 ${item.tagColor}`}>
                {item.tag}
              </span>

              {/* Heat */}
              <span className="text-xs text-foreground-500 font-medium w-16 text-right shrink-0">
                {item.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}